import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { BCMCLPUser, TeamCodes } from '../../../models/clpuser.model';
import { CMClub, CMClubResponse, CMSite, CMSiteListResponse } from '../../../models/cm-club-service.model';
import { REF_CMStatus, REF_CMStatusResponse, } from '../../../models/cm-contract';
import { eSectionLead } from '../../../models/contact-modal/contact.model';
import { UserDD } from '../../../models/generic-response.model';
import { MemContactListRequest, REF_MemCSStatus, MemContactResponse, MemContactItem } from '../../../models/membership.model';
import { CMClubService } from '../../../services/cm-club.service';
import { CMContractService } from '../../../services/cm-contract.service';
import { MembershipService } from '../../../services/membership.service';
import { NotificationService } from '../../../services/notification.service';
import { GlobalService } from '../../../services/shared/global.service';
import { LocalService } from '../../../services/shared/local.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { TeamOfficeService } from '../../../services/team-office.service';
import { UserService } from '../../../services/user.service';
declare var $: any;

@Component({
    selector: 'app-mem-contact-list',
    templateUrl: './mem-contact-list.component.html',
    styleUrls: ['./mem-contact-list.component.css']
})
/** mem-contact-list component*/
export class MemContactListComponent {
    encryptedUser: string;
    showSpinner: boolean;
    user: BCMCLPUser;
    contactList: MemContactItem[];
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    dataSource: MatTableDataSource<MemContactItem>;
    columns = [
        { field: 'name', title: 'Name', width: '184' },
        { field: 'email', title: 'Email', width: '70' },
        { field: 'mobile', title: 'Mobile', width: '142' },
        { field: 'cmContractID', title: 'Contract', width: '142' },
        { field: 'memberStatus', title: 'Status', width: '142' },
        { field: 'membershipID', title: 'Membership Name', width: '142' },
        { field: 'subscriptionID', title: 'Subscription ID', width: '142' },
        { field: 'onboardedByCLPUser', title: 'Onboarded By', width: '142' },
        { field: 'dateOfLastReservation', title: 'Last Reservation', width: '142' },
    ];

    /*FILTER*/
    clpUsersDD: UserDD[];
    memContactListDisplayColumns: string[];
    createDateFilters = [
        {
            "value": 1,
            "name": "This Month"
        },
        {
            "value": 2,
            "name": "Last Month"
        },
        {
            "value": 3,
            "name": "Custom"
        }
    ]
    customFilter: boolean = false;
    customDateStr: string = '';
    selectedCtDtFilterName: string;
    selectedCtDtFilter: number = 1;
    currentRange = new FormGroup({
        start: new FormControl<Date | null>(null),
        end: new FormControl<Date | null>(null),
    });
    selectedCustomdtStart: string;
    selectedCustomdtEnd: string;
    teamSub: Subscription;
    clpCompanyId: number;
    clubConfig: CMClub;
    cmSites: CMSite[];
    selectedUserID: number = 0;
    users: number[];
    selectedCMSiteID: number = 0;
    sites: number[];
    curTeam: TeamCodes = <TeamCodes>{};
    cmStatusList: REF_CMStatus[];
    cmStatusResponse: REF_CMStatusResponse;
    selectedStatusID: number = 0;
    ref_MemCSStatus: REF_MemCSStatus[];
    //End Filter
    sendMailInfo: any = { isShow: false, contactId: 0 };
    selectedContactId: number = 0;
    private destroy$ = new Subject<void>();

    constructor(private _localService: LocalService,
        private _globalService: GlobalService,
        private _utilityService: UtilityService,
        private _router: Router,
        private _notifyService: NotificationService,
        //private _contractService: CMContractService,
        private _memberShipService: MembershipService,
        private userService: UserService,
        private clubService: CMClubService,
        private datePipe: DatePipe,
        private _teamOfficeService: TeamOfficeService,
        private _cmContacrtService: CMContractService

    ) {
        this._localService.setShowMenu(true);
        this._localService.setIsContract(false);
        this._localService.setIsMembership(true);
        this._localService.updateTeamDD(true);
        this._localService.setRouteName("mem-contact-list");
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();
    }

    ngOnInit() {
        this.encryptedUser = localStorage.getItem("token");
        if (this.encryptedUser) {
            this.authenticateR().then(() => {
                if (this.user) {
                    this.clpCompanyId = this.user?.cLPCompanyID;
                    this.load();

                }
                else {
                    this._router.navigate(['/unauthorized']);
                }
            });
        }
        else {
            this._router.navigate(['/unauthorized']);
        }
    }

    async load() {
        this.teamSub = this._teamOfficeService.curTeam.pipe(takeUntil(this.destroy$)).subscribe(async (data: any) => {
            if (data != 0 && data != null) {
                this.curTeam = data;
                await this.CMClub_Get();
                await this.siteSearch();
                this.ref_MemCSStatus = this._localService.refMem_GetAllResponse.ref_MemCSStatus_List;
                await this.getCmMemberStatus();
                await this.cLPUserGetListByTeamCode(this.clpCompanyId, this.curTeam?.teamCode);
                await this.getmemContact_CMMember_List();
            }
            else {
                this.curTeam = JSON.parse(localStorage.getItem("curTeam") || "{}")
                await this.CMClub_Get();
                await this.siteSearch();
                this.ref_MemCSStatus = this._localService.refMem_GetAllResponse.ref_MemCSStatus_List;
                await this.getCmMemberStatus();
                await this.cLPUserGetListByTeamCode(this.clpCompanyId, this.curTeam?.teamCode);
                await this.getmemContact_CMMember_List();
            }
        })
    }

    async getCmMemberStatus() {
        await this._cmContacrtService.cmMemberStatus_GetList(this.encryptedUser)
            .then(async (result: REF_CMStatusResponse) => {
                if (result) {
                    this.cmStatusResponse = UtilityService.clone(result);
                    this.cmStatusList = this.cmStatusResponse.cmStatusList;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("mem-Contact.cmMemberStatus_GetList", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    private async authenticateR() {
        await this._localService.authenticateUser(this.encryptedUser)
            .then(async (result: BCMCLPUser) => {
                if (result) {
                    this.user = UtilityService.clone(result);
                    if (result?.strToken && result?.strToken != '') {
                        this.encryptedUser = result?.strToken;
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("navMenu.authenticateR", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async getmemContact_CMMember_List() {
        this.showSpinner = true
        let memContactRequest: MemContactListRequest = <MemContactListRequest>{};
        memContactRequest.clubId = this.clubConfig?.clubId;
        memContactRequest.clpCompanyId = this.user?.cLPCompanyID;
        memContactRequest.dateType = this.selectedCtDtFilter;
        memContactRequest.dtEnd = '';
        memContactRequest.dtStart = '';
        memContactRequest.strdtEnd = this.selectedCustomdtEnd;
        memContactRequest.strdtStart = this.selectedCustomdtStart;
        memContactRequest.timeFrame = 1;
        memContactRequest.users = this.users;
        memContactRequest.status = +this.selectedStatusID;
        await this._memberShipService.memContact_cmMember_GetList(this.encryptedUser, memContactRequest, this.user?.cLPUserID)
            .then(async (result: MemContactResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.contactList = response.contacts;
                    this.setGrid(this.contactList);
                }
                this.showSpinner = false
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false
                this._globalService.error("mem-contact-list.getCMMember_Contact_List", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    setGrid(list) {
        this.memContactListDisplayColumns = this.columns.map(c => c.field);
        this.dataSource = new MatTableDataSource(list);
        this.addTimeout(() => {
            this.dataSource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = 50;
            }
            if (this.sort) {
                this.dataSource.sort = this.sort;
            }
        }, 500)
    }
    selectRow(row: any) {
        console.log(row)
        const _route = `/mem-contact/${row?.contactID}`;
        window.open(_route, '_blank');
        //this._router.navigate(['/mem-contact/', row?.contactID]
        //    );
    }


    async CMClub_Get() {
        if (this.curTeam?.teamCode > 0) {
            await this.clubService.CMClub_Get(this.encryptedUser, this.clpCompanyId, this.curTeam?.teamCode).
                then(async (result: CMClubResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.clubConfig = response?.clubConfig;
                    }

                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }


    async cLPUserGetListByTeamCode(clpCompanyId, teamCode) {
        await this.userService.cLPUserGetListByTeamCode(this.encryptedUser, clpCompanyId, teamCode ? teamCode : this.user?.cLPUserID).
            then(async (result: UserDD[]) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.clpUsersDD = response
                    this.clpUsersDD.unshift({
                        value: 0,
                        text: "--ALL--"
                    })
                }

            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                    'clpCompanyId: ' + this.clpCompanyId
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async siteSearch() {
        if (this.clubConfig?.clubId > 0) {
            await this.clubService.siteSearch(this.encryptedUser, 0, this.clubConfig?.clubId, 0, 0).
                then(async (result: CMSiteListResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.cmSites = response?.sites
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }


    async onChangeUserDD() {
        if (this.selectedUserID > 0) {
            this.users = [];
            this.users.push(this.selectedUserID);
            await this.getmemContact_CMMember_List();
        }
        else {
            this.users = [];
            await this.getmemContact_CMMember_List();
        }
    }

    async onChangeCMSite() {
        if (this.selectedCMSiteID > 0) {
            this.sites = [];
            this.sites.push(this.selectedCMSiteID);
            await this.getmemContact_CMMember_List();
        }
        else {
            this.sites = [];
            await this.getmemContact_CMMember_List();
        }
    }

    async createDtFilterChange() {
        let value = this.selectedCtDtFilter;

        if (value != 3) {
            this.selectedCtDtFilter = +value;
            await this.getmemContact_CMMember_List();
        }
        else {
            this.customDateStr = ''
            this.customFilter = true;
        }
    }

    revertCustomFinalizeddtFilter() {
        this.customFilter = false;
        this.selectedCtDtFilter = 1;
        this.selectedCtDtFilterName = "This Month";
        this.currentRange = new FormGroup({
            start: new FormControl<Date | null>(null),
            end: new FormControl<Date | null>(null),
        });
        this.getmemContact_CMMember_List();
    }


    dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
        var startDt = dateRangeStart.value;
        var endDt = dateRangeEnd.value;
        if (startDt) {
            let customdtStart = this.datePipe.transform(startDt, 'MMddyyyy');
            this.selectedCustomdtStart = customdtStart;

        }
        if (endDt) {
            let customdtEnd = this.datePipe.transform(endDt, 'MMddyyyy');
            this.selectedCustomdtEnd = customdtEnd;
            //this.selectedCtDtFilter = 3;
            this.selectedCtDtFilterName = "Custom"
            if (this.selectedCustomdtStart && this.selectedCustomdtEnd != null) {
                this.getmemContact_CMMember_List();
            }
        }
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim().toLowerCase();
        if (this.dataSource) {
            this.dataSource.filter = filterValue;
        }
    }

    async onChangeMemberStatusDD() {
        await this.getmemContact_CMMember_List();
    }


    gotoLink(event, columnName, dataItem) {
        switch (columnName) {
            case "email":
                {
                    $('#sendEmail').modal('show');
                    this.sendMailInfo.isShow = true;
                    this.sendMailInfo.contactId = dataItem?.contactID;
                }
                break;
            case "memContact":
                {
                    const _route = `/mem-contact/${dataItem?.contactID}`;
                    window.open(_route, '_blank');
                }
                break;
            case "mobile":
                {
                    this.selectedContactId = dataItem?.contactID;
                    $('#sendTextModal').modal('show');
                }
                break;
            case "cmContract":
                {
                    let url = "cm-contract/" + dataItem?.contactID + '?r=' + this.encryptedUser
                    window.open(url, '_blank')
                }
                break;
            case "memMemberShip":
                {
                    const url = `/mem-membership/${dataItem?.membershipIID}`;
                    window.open(url, '_blank');
                }
                    break;
            case "memSubscription":
                {
                    const url = `/mem-subscription?subscriptionID=${dataItem?.membershipIID}`;
                    window.open(url, '_blank');
                }
                    break;
            default:
        }
    }

    hideSendMail() {
        $('#sendEmail').modal('hide');
        this.sendMailInfo.isShow = false;
        this.sendMailInfo.contactId = 0;
    }

    hideTextMsgModal(sms?: boolean) {
        this.selectedContactId = 0;
        $('#sendTextModal').modal('hide');
    }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

}
